/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrescriptionOrderSummaryDto
 */
export interface PrescriptionOrderSummaryDto {
    /**
     * Prescription order ID (internal UUID)
     * @type {string}
     * @memberof PrescriptionOrderSummaryDto
     */
    id: string;
    /**
     * External order ID from the 3rd party provider
     * @type {string}
     * @memberof PrescriptionOrderSummaryDto
     */
    externalOrderId: string | null;
    /**
     * External resource provider
     * @type {string}
     * @memberof PrescriptionOrderSummaryDto
     */
    externalResource: PrescriptionOrderSummaryDtoExternalResourceEnum;
    /**
     * Order creation timestamp
     * @type {Date}
     * @memberof PrescriptionOrderSummaryDto
     */
    createdAt: Date;
    /**
     * Order last update timestamp
     * @type {Date}
     * @memberof PrescriptionOrderSummaryDto
     */
    updatedAt: Date;
    /**
     * Order status from 3rd party provider (e.g., 'NEW', 'Pending')
     * @type {string}
     * @memberof PrescriptionOrderSummaryDto
     */
    status?: string | null;
    /**
     * Total price of the order from 3rd party provider
     * @type {number}
     * @memberof PrescriptionOrderSummaryDto
     */
    total?: number | null;
    /**
     * Shipping address
     * @type {string}
     * @memberof PrescriptionOrderSummaryDto
     */
    shippingAddress?: string | null;
    /**
     * City
     * @type {string}
     * @memberof PrescriptionOrderSummaryDto
     */
    shippingCity?: string | null;
    /**
     * State
     * @type {string}
     * @memberof PrescriptionOrderSummaryDto
     */
    shippingState?: string | null;
}


/**
 * @export
 */
export const PrescriptionOrderSummaryDtoExternalResourceEnum = {
    PersonalizedNutrients: 'personalized_nutrients',
    CelleraMedicine: 'cellera_medicine',
    RxntEhr: 'rxnt_ehr'
} as const;
export type PrescriptionOrderSummaryDtoExternalResourceEnum = typeof PrescriptionOrderSummaryDtoExternalResourceEnum[keyof typeof PrescriptionOrderSummaryDtoExternalResourceEnum];


/**
 * Check if a given object implements the PrescriptionOrderSummaryDto interface.
 */
export function instanceOfPrescriptionOrderSummaryDto(value: object): value is PrescriptionOrderSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('externalOrderId' in value) || value['externalOrderId'] === undefined) return false;
    if (!('externalResource' in value) || value['externalResource'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PrescriptionOrderSummaryDtoFromJSON(json: any): PrescriptionOrderSummaryDto {
    return PrescriptionOrderSummaryDtoFromJSONTyped(json, false);
}

export function PrescriptionOrderSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrescriptionOrderSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'externalOrderId': json['externalOrderId'],
        'externalResource': json['externalResource'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'status': json['status'] == null ? undefined : json['status'],
        'total': json['total'] == null ? undefined : json['total'],
        'shippingAddress': json['shippingAddress'] == null ? undefined : json['shippingAddress'],
        'shippingCity': json['shippingCity'] == null ? undefined : json['shippingCity'],
        'shippingState': json['shippingState'] == null ? undefined : json['shippingState'],
    };
}

export function PrescriptionOrderSummaryDtoToJSON(json: any): PrescriptionOrderSummaryDto {
    return PrescriptionOrderSummaryDtoToJSONTyped(json, false);
}

export function PrescriptionOrderSummaryDtoToJSONTyped(value?: PrescriptionOrderSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'externalOrderId': value['externalOrderId'],
        'externalResource': value['externalResource'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'status': value['status'],
        'total': value['total'],
        'shippingAddress': value['shippingAddress'],
        'shippingCity': value['shippingCity'],
        'shippingState': value['shippingState'],
    };
}

